export const RECEIVED = 'PREC';
export const PERSON_CREATION_SUCCESS = 'PERS';
export const PERSON_CREATION_FAILURE = 'PERF';
export const POLICY_CREATION_SUCCESS = 'POCS';
export const POLICY_CREATION_FAILURE = 'POCF';
export const PAYMENT_APPROVED = 'PAYA';
export const PAYMENT_DENIED = 'PAYD';
export const PAYMENT_FAILED = 'PAYF';
export const POLICY_ACTIVATION_SUCCESS = 'POAS';
export const POLICY_ACTIVATION_FAILURE = 'POAF';
export const PAYMENT_APPLICATION_SUCCESS = 'PAAS';
export const PAYMENT_APPLICATION_FAILURE = 'PAAF';
